<template>
  <img
    src="https://zsrbapp.zsnews.cn/mobile/images/zsplus.png"
    width="0px"
    height="0px"
    style="position: absolute"
  />
  <div class="article-header-container">
    <div
      class="article-header"
      v-if="isWechat"
    >
      <wx-open-launch-app
        id="launch-btn"
        appid="wxc9da92efaf026389"
        style="width: 100vw; height: 100%"
        :extinfo="article.dataInfo"
        @launch="handleLaunch"
        @error="handleError"
      >
        <component
          :is="'script'"
          v-bind="{ type: 'text/wxtag-template' }"
        >
          <button
            style="
              color: red;
              font-size: 12px;
              background-color: white;
              float: right;
              border: 1px solid red;
              border-radius: 12.5px;
              margin-top: 9px;
              width: 80px;
              height: 25px;
              margin-right: 20px;
            "
            class="btn"
          >
            打开APP
          </button>
        </component>
      </wx-open-launch-app>
    </div>
  </div>
  <NormalNewsDetail
    :article="article"
    :reporter-list="reporterList"
    :relate-list="relateList"
    :info-list="infoList"
    :info-list-total="infoListTotal"
    :info-extend="infoExtend"
    @load-more="handleLoadMore"
    view-model="detail"
  />
</template>

<script>
import { Toast } from "@vant/compat";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import Api from "@/api";
import NormalNewsDetail from "@/components/NormalNewsDetail.vue";
import useShare from "@/composiables/useShare";
export default {
  name: "Home",
  components: {
    NormalNewsDetail
  },
  setup() {
    const userAgentString = navigator.userAgent.toLowerCase();
    const isWechat = userAgentString.indexOf("micromessenger") >= 0;
    const article = ref({ model: {} });
    const reporterList = ref([]);
    const relateList = ref([]);
    const infoList = ref([]);
    const infoListTotal = ref(0);
    const infoExtend = ref({});
    const handleLaunch = (e) => {
      console.log("handleLaunch", e);
    };

    const handleError = (e) => {
      console.log("handleError", e);
      window.open(article.value.apkLink, "_blank");
    };

    const handleLoadMore = (params) => {
      Api.getInfoListPreview(params).then((res) => {
        if (res.code === 1) {
          infoList.value = res.data.list;
          infoListTotal.value = res.data.total;
        }
      });
    };

    onMounted(() => {
      const route = useRoute();
      if (route.params.id) {
        // 获取新闻详情
        Api.getArticle(route.params.id).then((res) => {
          if (res.code !== 0) {
            Toast(res?.error);
            return;
          }
          const art = res.data;
          article.value = art;
          const url =
            "https://zsrbapp.zsnews.cn/mobile/news/viewNews/" +
            route.params.id +
            "?t=" +
            Date.parse(new Date());
          document.title = art.model.title;
          //
          useShare(art.model.title, art.model.shareimg, art.model.summary, url);
          window.TrackKit.umengAdapter.setExposure({
            category: "ImageTextDetail",
            title: art.model.title + "#" + art.model.publishTime
          });
          if (art.model.linkUrl) {
            window.location.href = art.model.linkUrl;
          } else {
            // 获取最新评论
            Api.getInfoListPreview({
              id: route.params.id,
              page: 1,
              page_size: 5
            }).then((res) => {
              if (res.code === 1) {
                infoList.value = res.data.list;
                infoListTotal.value = res.data.total;
              }
            });
            // 获取评论点赞等信息
            Api.getInfoExtend(route.params.id).then((res) => {
              if (res.code === 1) {
                infoExtend.value = res.data;
              }
            });
            // 获取记者列表
            Api.getReporterList(route.params.id).then((res) => {
              if (res.code === 1) {
                reporterList.value = res.data;
              }
            });
            // 获取相关新闻
            Api.getRelateList(route.params.id).then((res) => {
              if (res.code === 1) {
                relateList.value = res.data;
              }
            });
          }
        });
        window.TrackKit.zmyAdapter.openArticle({
          article_id: route.params.id
        });
      } else {
        Toast.fail("文章id缺失");
      }
    });

    return {
      handleLaunch,
      handleError,
      handleLoadMore,
      article,
      reporterList,
      relateList,
      infoList,
      infoListTotal,
      infoExtend,
      isWechat
    };
  }
};
</script>

<style lang="scss" scoped>
.article-header-container {
  position: fixed;
  width: 100%;
  z-index: 99;
}

.article-header {
  background-color: white;
  background-image: url("../assets/img/header.png");
  background-size: contain;
  background-repeat: no-repeat;
  height: 40px;
  padding: 5px;
}
</style>
